import React from 'react';
import {useStateContext} from "../contexts/ContextProvider";
import {Divider, Tooltip} from "@chakra-ui/react";

export const Heading = ({content}) => {
    const {main} = useStateContext();
    const second = main === "eng" ? "hun" : "eng";

    return (
        <>
            <Divider className="p-4" />
            <h2
                className="text-2xl font-bold text-center p-8"
            >
                <Tooltip
                    label={content[second]}
                    aria-label={content[main]}>
                    {content[main]}
                </Tooltip>
            </h2>
        </>
    );
};
